import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useFetchWithToken } from "../auth/authorization";

export default function ManagePoints() {
    const [points, setPoints] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiBase = process.env.REACT_APP_SERVER_API_URL || "";
    const base = apiBase.replace(/\/$/, "");
    const location = useLocation();

    const fetchWithToken = useFetchWithToken();

    useEffect(() => {
        let cancelled = false;
        async function fetchPoints() {
            try {
                const res = await fetch(`${base}/api/points`);
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                if (cancelled) return;
                setPoints(Array.isArray(data) ? data : []);
            } catch (e) {
                console.error("Failed to load points:", e);
                if (!cancelled) setError(e instanceof Error ? e.message : String(e));
            } finally {
                if (!cancelled) setLoading(false);
            }
        }
        fetchPoints();
        return () => { cancelled = true; };
    }, [base]);

    async function handleDelete(id) {
        if (!window.confirm("Delete this point?")) return;
        try {
            const res = await fetchWithToken(
                `${base}/api/points/${id}`,
                { method: "DELETE" }
            );
            const data = await res.json().catch(() => null);
            if (!res.ok) {
                const msg = (data && (data.message || data.Message)) || `HTTP ${res.status}`;
                throw new Error(msg);
            }
            setPoints(prev => prev.filter(p => p.id !== id));
        } catch (err) {
            console.error("Failed to delete point:", err);
            alert(err instanceof Error ? err.message : String(err));
        }
    }

    if (loading) return <div className="container"><p>Loading points</p></div>;
    if (error) return <div className="container"><div className="alert alert-danger">Failed to load points: {error}</div></div>;

    return (
        <main className="container">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Manage Points</h3>
                <div className="d-flex align-items-center">
                    <div>
                        <Link
                            className="btn btn-sm btn-success"
                            to="/manage/create"
                            state={{ from: location.pathname }}
                        >
                            Add Point
                        </Link>
                    </div>
                </div>
            </div>

            {points.length === 0 ? (
                <div className="alert alert-info">No points found.</div>
            ) : (
                <div className="table-responsive">
                    <table className="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Actions</th>
                                <th>Name</th>
                                <th>Civic Address</th>
                                <th>Email</th>
                                <th>OrganizationType</th>
                                <th>Phone</th>
                                <th>Socials</th>
                                <th>Website</th>
                            </tr>
                        </thead>
                        <tbody>
                            {points.map(p => (
                                <tr key={p.id ?? `${p.lat}-${p.lng}`}>
                                    <td>
                                        <div className="btn-group" role="group">
                                            <Link
                                                className="btn btn-sm btn-outline-primary"
                                                to={`/manage/edit/${encodeURIComponent(p.id)}`}
                                                state={{ from: location.pathname }}
                                            >
                                                Edit
                                            </Link>
                                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(p.id)}>Delete</button>
                                        </div>
                                    </td>
                                    <td>{p.name ?? "Point"}</td>
                                    <td>{p.civicAddress ?? "CivicAddress"}</td>
                                    <td>{p.email}</td>
                                    <td>{p.fundingBusinessModelGovernanceOrganizationType}</td>
                                    <td>{p.phone}</td>
                                    <td>{p.facebook ?? ""} {p.instagram ?? ""}</td>
                                    <td>{p.website}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </main>
    );
}